import React from 'react';

import {
  Box,
  Button,
  FormField,
  FormHelp,
  Heading,
  Input,
  Label,
  Page,
  Paragraph,
  TextButton,
} from '@zillow/constellation-10';

import { setCookie } from '../utils/cookies';
import { IconChevronLeftFilled } from '@zillow/constellation-icons';

export default class DevLoginPage extends React.Component {
  state = { ssid: '' };

  setSsid = (event: React.FormEvent<HTMLInputElement>) => this.setState({ ssid: event.currentTarget.value });

  setCookiesAndRedirect = () => {
    const { ssid } = this.state;

    setCookie('ZILLOW_SSID', ssid);

    const queryParams = new URLSearchParams(window.location.search);
    const href = queryParams.get('url');

    if (href) {
      window.location.href = href;
    }
  };

  render() {
    const { ssid } = this.state;

    return (
      <Page.Root css={{ background: 'bg.neutral' }}>
        <Page.Breadcrumb>
          <TextButton asChild icon={<IconChevronLeftFilled />}>
            <a href="https://zillow.com/rental-manager/">Back to Zillow Rental Manager</a>
          </TextButton>
        </Page.Breadcrumb>
        <Page.Header>
          <Heading level={1}>Leases</Heading>
        </Page.Header>
        <Page.Content>
          <Box css={{ padding: 'tight' }}>
            <Heading level={2} css={{ textStyle: 'responsive.heading-sm', marginBottom: 'tight' }}>
              Aw poo
            </Heading>
            <Paragraph css={{ marginBottom: 'tight' }}>You’re not logged in and you’ve been redirected!</Paragraph>
            <FormField
              css={{ marginBottom: 'tight' }}
              label={<Label htmlFor="ssid-input">Zillow_SSID</Label>}
              control={<Input id="ssid-input" value={ssid} onChange={this.setSsid} fluid={false} />}
              description={<FormHelp>Reach out on #leases-engineering on Slack if you have trouble</FormHelp>}
            />
            <Button tone="brand" emphasis="filled" onClick={this.setCookiesAndRedirect} disabled={ssid === ''}>
              Log in
            </Button>
          </Box>
        </Page.Content>
      </Page.Root>
    );
  }
}
